import { mutator } from 'satcheljs';
import { onSearchInputFocused } from '../actions/internalActions';
import { searchBoxBlurred } from '../actions/publicActions';
import getScenarioStore from '../selectors/getScenarioStore';

mutator(onSearchInputFocused, actionMessage => {
    getScenarioStore(actionMessage.scenarioId).searchBoxHasFocus = true;
});

mutator(searchBoxBlurred, actionMessage => {
    getScenarioStore(actionMessage.scenarioId).searchBoxHasFocus = false;
});
